import api from "../config/axiosInstance";
import { API } from "../config/API";

const GET = async (url: any, params: any, token: any) => {
  const response = await api.get(url, { params });
  return response.data;
};

const POST = async (url: any, body: any) => {
  const response = await api.post(url, body);
  return response.data;
};

// Like POST, but opts the request out of the global 401 -> token-refresh ->
// forced-logout flow (see axiosInstance interceptor). Use for non-critical
// data/export calls whose 401 must NOT end the admin's session.
const POST_NO_LOGOUT = async (url: any, body: any) => {
  const response = await api.post(url, body, { skipAuthLogout: true } as any);
  return response.data;
};

const PUT = (url: any, body: any) => {
  return api.put(url, body).then((response) => response.data);
};

const PATCH = (url: any, body: any) => {
  return api.patch(url, body).then((response) => response.data);
};

const DELETE = (url: any) => {
  return api.delete(url).then((response) => response.data);
};

const CREATELOGS = (body: any) => {
  return api
    .post(API.CREATE_LOGS, { data: body })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Failed to create log:", error);
    });
};

export { GET, POST, POST_NO_LOGOUT, PUT, PATCH, DELETE, CREATELOGS };
